import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { SelectValidator } from 'react-material-ui-form-validator';
import CircularProgress from '@material-ui/core/CircularProgress';
import { MenuItem } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface IMonthsDropDownProps {
    setMonths?: (event) => void;
    months: number | undefined;
    disabled: boolean;
}

interface IMonthsDropDownState {
    model: number[];
    loaded: boolean;
}

class MonthsAtAddressDropDown extends Component<IMonthsDropDownProps & WithStyles<typeof styles>, IMonthsDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
            loaded: false
        }
    }

    componentDidMount() {

        this.setState({
            loaded: true,
        });
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key="defaultmonth" value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={item} value={item}>{item}</MenuItem>
            );
        }

        return (
            <SelectValidator
                label={"Number of Months *"}
                name="taaMonths"
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.months}
                onChange={this.props.disabled ? undefined : this.props.setMonths}
                disabled={this.props.disabled}
                validators={['required']}
                errorMessages={['This field is required']}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }
}

export default withStyles(styles)(MonthsAtAddressDropDown);